import { MAX_HOURS_PER_DAY, isValidHoursPerDay } from "routes/rate-cards/capacity-constants.mjs"

export function getHoursPerDayError(value) {
    if (isBlank(value)) return ""
    const parsed = parseStrictNumber(value)
    if (isValidHoursPerDay(parsed)) return ""
    return `Enter more than 0 and no more than ${MAX_HOURS_PER_DAY}`
}

export function hasInvalidWorkingTime(target) {
    return Boolean(getHoursPerDayError(target?.hoursPerDay))
}

export function parseOptionalWorkingTime(value) {
    if (isBlank(value)) return null
    return parseStrictNumber(value)
}

function parseStrictNumber(value) {
    if (typeof value === "number") return value
    return Number(String(value).trim())
}

function isBlank(value) {
    return value == null || String(value).trim() === ""
}
